import { handleActions } from 'redux-actions';
import Actions from '../actions/actions';
import { TemplatesCRUDActions } from '../actions/TemplatesCRUDActions';
import { TemplateState } from '../interfaces/templates';
import { TemplateModel } from '../model/TemplateModel';
import { Pagination } from '../store-interfaces';
import { setBusy, setUnBusy } from './common/commonReducers';

type ActionType = {
  type: string;
  entities?: {
    templates: TemplateModel[];
    pagination: Pagination;
  };
  entity?: TemplateModel;
};

const onGetAll = (state: TemplateState, action: ActionType) => {
  return {
    busy: false,
    entities: action.entities ? action.entities.templates : [],
    pagination: action.entities ? action.entities.pagination : {},
  };
};

const onSet = (state: TemplateState, action: ActionType) => {
  if (
    !action.entity ||
    state.entities.find(
      e => (action.entity && e.id === action.entity.id) || false,
    )
  ) {
    return {
      pagination: state.pagination,
      entities: state.entities.map(e =>
        action.entity && e.id === action.entity.id ? action.entity : e,
      ),
      busy: false,
    };
  }

  return {
    pagination: state.pagination,
    busy: false,
    entities: [action.entity, ...state.entities],
  };
};

const onDelete = (state: TemplateState, action: ActionType) => ({
  busy: false,
  pagination: state.pagination,
  entities: state.entities.filter(
    e => action.entity && e.id !== action.entity.id,
  ),
});

const initialState: TemplateState = {
  busy: false,
  entities: [],
  pagination: {
    isLastPage: true,
    page: 0,
    perPage: 0,
    total: 0,
    totalPages: 0,
  },
};

const mappedReducers = {
  [TemplatesCRUDActions.busyAction]: (state: TemplateState) => setBusy(state),
  [TemplatesCRUDActions.getTemplatesAction]: onGetAll,
  [TemplatesCRUDActions.getTemplateByIdAction]: onSet,
  [TemplatesCRUDActions.setTemplateAction]: onSet,
  [TemplatesCRUDActions.updateTemplateAction]: onSet,
  [TemplatesCRUDActions.deleteTemplateAction]: onDelete,
  [TemplatesCRUDActions.deleteLocalAction]: () => initialState,
  [Actions.RESET]: () => initialState,
  [Actions.UNBUSY]: setUnBusy,
};

export const templates = handleActions(mappedReducers, initialState);
